import { gql } from '@apollo/client';

export const activateCards = gql`
  mutation activateCards($input: ActivateCardsInput!) {
    activateCards(input: $input) {
      altId
      externalNumber
      cardStatus
      driver {
        altId
      }
    }
  }
`;
